window.DisplayBlogPosts = (phrase) => {
    return {
        val: phrase,
    };
};
